/** KAN-997: итоги пула Telegram из ответа API (бэкенд считает, строки не пересчитываются). */
import type { TgPoolSummary } from '@/services/api/platform';

export function PoolSummary({ summary }: { summary: TgPoolSummary }) {
  return (
    <p data-testid="platform-pool-summary" className="flex flex-wrap gap-x-4 text-sm text-gray-600">
      <span>
        Здоровых: <span className="font-semibold text-gray-900">{summary.healthy}</span>
      </span>
      <span>
        всего подключено: <span className="font-semibold text-gray-900">{summary.connected}</span>
      </span>
      <span>
        были под флудом: <span className="font-semibold text-gray-900">{summary.flooded}</span>
      </span>
    </p>
  );
}
